import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, credentials);
      localStorage.setItem('admin_token', response.data.access_token);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="py-20 md:py-32">
        <div className="max-w-md mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-semibold text-black mb-12 text-center" data-testid="admin-login-title">
            Admin Login
          </h1>

          <div className="bg-white border-2 border-gray-100 p-8 rounded-2xl">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="username" className="text-lg font-semibold text-black mb-2 block">
                  Username
                </Label>
                <Input
                  id="username"
                  type="text"
                  value={credentials.username}
                  onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                  className="h-14 px-4 bg-gray-50 border-2 border-transparent focus:border-[#0044CC] focus:bg-white rounded-xl text-lg w-full transition-all"
                  data-testid="username-input"
                  required
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-lg font-semibold text-black mb-2 block">
                  Password
                </Label>
                <Input
                  id="password"
                  type="password"
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  className="h-14 px-4 bg-gray-50 border-2 border-transparent focus:border-[#0044CC] focus:bg-white rounded-xl text-lg w-full transition-all"
                  data-testid="password-input"
                  required
                />
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-[#0044CC] text-white hover:bg-[#0044CC]/90 h-14 px-8 rounded-full font-semibold text-lg transition-colors"
                data-testid="login-button"
              >
                {loading ? 'Logging in...' : 'Login'}
              </Button>
            </form>

            <div className="mt-6 p-4 bg-gray-50 rounded-xl">
              <p className="text-sm text-[#333333] text-center">
                Default credentials: admin / admin123
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AdminLoginPage;